import classNames from "./styles.module.scss"

export const Watermark = () => {


  return <div className={classNames.watermark}>
    <p className={classNames.topText}>Сервис разработан компанией Самара-Информспутник.</p>

    <p className={classNames.bottomText}>
      <a href="https://ksdm.geosamara.ru/" target="_blank" style={{ textDecoration: 'none' }}>Все услуги, продукты и сервисы</a>
    </p>

  </div>

}